/* eslint-disable @typescript-eslint/no-explicit-any */
import type { movimentType, patchMovimentsType } from "../types/cashFlow";
import api from "./api";

export interface ICashFlowOrder {
  codigo?: "ASC" | "DESC";
  data?: "ASC" | "DESC";
  fluxo?: "ASC" | "DESC";
  tipo?: "ASC" | "DESC";
  descricao?: "ASC" | "DESC";
  plano?: "ASC" | "DESC";
  centro?: "ASC" | "DESC";
  conta?: "ASC" | "DESC";
  valor?: "ASC" | "DESC";
}

export interface ICashFlowFilters {
  uid_estabelecimento?: string;
  inicio?: string;
  fim?: string;
  conta_financeira?: string;
  uid_plano_contas?: string;
  uid_centro_custo?: string;
  tipo?: "entrada" | "saida" | "";
  tipo_data?: "movimentacao" | "competencia" | "vencimento";
  origem?: string;
  realizado?: boolean;
  previsto?: boolean;
  incluir_atrasados?: boolean;
}

export const getMovimentsCashFlow = async (
  filters: ICashFlowFilters,
  search?: string,
) => {
  try {
    const res = await api.get(`/cashFlow`, {
      params: {
        filter: {
          inicio: filters.inicio,
          fim: filters.fim,
          conta_financeira: filters.conta_financeira,
          uid_plano_contas: filters.uid_plano_contas,
          uid_centro_custo: filters.uid_centro_custo,
          tipo: filters.tipo,
          tipo_data: filters.tipo_data,
          origem: filters.origem,
        },
        search,
        realizado: filters.realizado,
        previsto: filters.previsto,
        incluir_atrasados: filters.incluir_atrasados,
      },
    });

    return res.data.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message = "Erro ao carregar movimentações";
    }
    throw error;
  }
};

export const getAccountBalances = async () => {
  try {
    const res = await api.get(`/cashFlow/getAccountBalances`);
    return res.data.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      "Erro ao carregar saldos das contas!"
    );
  }
};

export const postMoviments = async ({
  data_movimentacao,
  valor,
  tipo,
  descricao,
  uid_conta_financeira,
  uid_financeiro_lancamento,
  uid_plano_contas,
  uid_centro_custo,
  origem,
}: movimentType & { origem?: string }) => {
  try {
    const res = await api.post(`/cashFlow/postMoviments`, {
      data_movimentacao,
      valor,
      tipo,
      descricao,
      uid_conta_financeira,
      uid_financeiro_lancamento,
      uid_plano_contas,
      uid_centro_custo,
      origem,
    });
    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error.response?.data ||
      error?.message ||
      "Erro desconhecido!"
    );
  }
};

export const getMoviment = async (uid: string) => {
  try {
    const res = await api.get(`/cashFlow/getMoviment`, { params: { uid } });
    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message || error?.message || "Erro desconhecido!"
    );
  }
};

export const patchMoviments = async (data: patchMovimentsType) => {
  try {
    const res = await api.patch(`/cashFlow/patchMoviments`, { ...data });
    return res.data;
  } catch (error: any) {
    throw error;
  }
};

export const deleteMoviments = async (uid_financeiro_movimentacao: string) => {
  try {
    const res = await api.delete(`/cashFlow/deleteMoviments`, {
      params: { uid_financeiro_movimentacao },
    });
    return res.data;
  } catch (error: any) {
    throw error;
  }
};

export const getFinanceAccounts = async () => {
  try {
    const res = await api.get(`/cashFlow/getFinanceAccounts`);
    return res.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Erro desconhecido!";
  }
};

export const getChartOfAccounts = async (
  type: "receita" | "despesa" | "ambos",
) => {
  try {
    const res = await api.get(`/cashFlow/getChartOfAccounts`, {
      params: { type },
    });
    return res.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Erro ao carregar plano de contas!";
  }
};

export const getCostCenters = async () => {
  try {
    const res = await api.get(`/cashFlow/getCostCenters`);
    return res.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Erro ao carregar centros de custo!";
  }
};
